import { render, staticRenderFns } from "./PendingComplaint.vue?vue&type=template&id=3ea93846"
import script from "./PendingComplaint.vue?vue&type=script&lang=js"
export * from "./PendingComplaint.vue?vue&type=script&lang=js"
import style0 from "./PendingComplaint.vue?vue&type=style&index=0&id=3ea93846&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports